// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"6f266b4d","796":"a33d9e1e"}[chunkId] + ".chunk.js";
};